import Link from 'components/link'
import { storeSearchResultsPath } from 'lib/urls'
import { SectionHeading } from 'components/headings'
import MerchandisingMessage from 'components/merchandising-message'
import PriceDisplay from '../../price-display'
import { ReviewTeaser } from '../../product-reviews'
import InStockAlertLink from '../../in-stock-alert-link'
import {
  ProductCallouts,
  Callout,
} from 'components/ProductCallouts/ProductCallouts'
import { track } from 'lib/analytics'
import css from './styles.scss'

interface ProductInfoProps {
  brand: string
  brandPageUrl?: string
  callouts: Callout[]
  isElectronicGiftCard: boolean
  merchandisingMessage?: string
  name: string
  price: {
    current: number
    msrp: number
  }
  productId: number
  productType: string
  extendedDeliveryTimeMessage: string | null
  reviewSku: string
  showInStockNotificationLink: boolean
  showPrice: boolean
  surchargeModalPrompt: string | null
  reactRouterEnabled?: boolean | true
  titleDecorator?(component: any): any
}

const ProductInfo = ({
  brand,
  brandPageUrl,
  callouts,
  isElectronicGiftCard,
  merchandisingMessage,
  name,
  price,
  productId,
  productType,
  extendedDeliveryTimeMessage,
  surchargeModalPrompt,
  reactRouterEnabled = true,
  reviewSku,
  showInStockNotificationLink,
  showPrice,
  titleDecorator,
}: ProductInfoProps) => {
  return (
    <div>
      <SectionHeading className={css.productName}>
        <span className="h7 text-uppercase mtl mtn-sm mbs block">
          <Link
            className="link-body-text"
            newWindow={!reactRouterEnabled}
            to={
              reactRouterEnabled
                ? brandPageUrl || storeSearchResultsPath(brand)
                : undefined
            }
            url={!reactRouterEnabled && storeSearchResultsPath(brand)}
          >
            {brand}{' '}
          </Link>
        </span>
        <span>{titleDecorator ? titleDecorator(name) : name}</span>
      </SectionHeading>
      {/* @ts-ignore */}
      <ReviewTeaser sku={reviewSku} />
      {showPrice && (price || isElectronicGiftCard) ? (
        <p className="mvs">
          <PriceDisplay
            isElectronicGiftCard={isElectronicGiftCard}
            price={price}
            priceClassName="h4"
          />
        </p>
      ) : null}
      <MerchandisingMessage
        merchandisingMessage={merchandisingMessage}
        surchargeModalPrompt={surchargeModalPrompt}
      />
      <ProductCallouts
        callouts={callouts}
        eventLocation={track.EventLocation.PDP}
      />
      {showInStockNotificationLink && (
        <InStockAlertLink productId={productId} />
      )}
      {!showInStockNotificationLink && extendedDeliveryTimeMessage && (
        <p className="small mtm">{extendedDeliveryTimeMessage}</p>
      )}
      {productType === 'virtual_bundle' && (
        <div className="h7 mvs">Items may ship separately.</div>
      )}
    </div>
  )
}

export default ProductInfo
